// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__NqsPl","footer":"ModalCreateQualiphyProcedure_footer__M4iGK","additionData":"ModalCreateQualiphyProcedure_additionData__lBiOY"};